export default __webpack_public_path__ + "static/media/granville07.8692d3ea.jpg";